import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export const FloatingButtons = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [infoCompany, setInfoCompany] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    axios
      .get("/page-section/public/shows?sectionType=infoCompany")
      .then((res) => {
        setInfoCompany(res.data.data[0]);
      })
      .catch((err) => console.log(err));
  }, []);

  // Lấy cartCount từ localStorage (cập nhật khi cartUpdated)
  useEffect(() => {
    const updateCartCount = () => {
      const cartItems = JSON.parse(localStorage.getItem("cart")) || [];
      setCartCount(cartItems.length);
    };
    updateCartCount();
    window.addEventListener("cartUpdated", updateCartCount);
    return () => window.removeEventListener("cartUpdated", updateCartCount);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getUrlByKey = (key) => {
    if (!infoCompany || !infoCompany?.content) return "#";
    const item = infoCompany?.content?.find((item) => item.key === key);
    return item && item.url ? item.url : "#";
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes shake {
        0% { transform: rotate(0deg); }
        25% { transform: rotate(5deg); }
        50% { transform: rotate(0deg); }
        75% { transform: rotate(-5deg); }
        100% { transform: rotate(0deg); }
      }
      .floating-btn:hover {
        animation: shake 0.5s ease-in-out;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div>
      <div className="position-fixed z-[1000] left-3 bottom-12 opacity-[0.9] mb-8">
        <div className="d-flex flex-column mb-3 gap-2">
          {getUrlByKey("facebook") !== "#" && (
            <Link
              className={`w-12 h-12 border-2 border-white rounded-full flex items-center justify-center bg-white`}
              to={getUrlByKey("facebook")}
              target="_blank"
              rel="noopener noreferrer"
              title="Facebook"
            >
              <i className="facebook-icon inline-block"></i>
            </Link>
          )}

          {getUrlByKey("messenger") !== "#" && (
            <Link
              className={`w-12 h-12 border-2 border-white rounded-full flex items-center justify-center bg-white`}
              to={getUrlByKey("messenger")}
              target="_blank"
              rel="noopener noreferrer"
              title="Messenger"
            >
              <i className="messenger-icon inline-block"></i>
            </Link>
          )}

          {getUrlByKey("zalo") !== "#" && (
            <Link
              className={`w-12 h-12 border-2 border-white rounded-full flex items-center justify-center bg-white`}
              to={getUrlByKey("zalo")}
              target="_blank"
              rel="noopener noreferrer"
              title="Zalo"
            >
              <i className="zalo-icon"></i>
            </Link>
          )}

          {getUrlByKey("tiktok") !== "#" && (
            <Link
              className={`w-12 h-12 border-2 border-white rounded-full flex items-center justify-center bg-white`}
              to={getUrlByKey("tiktok")}
              target="_blank"
              rel="noopener noreferrer"
              title="TikTok"
            >
              <i className="tiktok-icon inline-block"></i>
            </Link>
          )}

          {getUrlByKey("youtube") !== "#" && (
            <Link
              className={`w-12 h-12 border-2 border-white rounded-full flex items-center justify-center bg-white`}
              to={getUrlByKey("youtube")}
              target="_blank"
              rel="noopener noreferrer"
              title="YouTube"
            >
              <i className="youtube-icon inline-block"></i>
            </Link>
          )}

          {getUrlByKey("number_phone") !== "#" && (
            <Link
              className="w-12 h-12 relative inline-flex items-center justify-center text-white bg-green-500 hover:bg-green-600 btn-square mr-2 mb-2 rounded-full border border-white"
              to={`tel:${getUrlByKey("number_phone")}`}
              rel="noopener noreferrer"
              title="Hotline"
            >
              <i className="fa-solid fa-phone-volume animate-shake-rotate"></i>
              <span className="absolute animate-ping-pulse inline-flex h-full w-full rounded-full bg-green-400 opacity-75 z-0"></span>
            </Link>
          )}
        </div>
      </div>

      <div className="position-fixed z-1000 right-2 bottom-12 opacity-[0.9]">
        <div className="d-flex flex-column mb-3">
          <Link
            className={`bg-secondary btn-square mr-2 mb-24 rounded-circle border border-white back-to-top transition-opacity duration-500 floating-btn
          ${
            isVisible
              ? "opacity-100 visible"
              : "opacity-0 invisible pointer-events-none"
          }`}
            onClick={scrollToTop}
            style={{ cursor: "pointer" }}
          >
            <i className="fa fa-angle-double-up"></i>
          </Link>
        </div>
      </div>

      {/* NÚT GIỎ HÀNG NỔI CHỈ MOBILE */}
      <button
        type="button"
        className="fixed md:hidden z-[1001] border-2 outline-none focus:outline-none active:outline-non border-white right-4 bottom-24 w-14 h-14 rounded-full bg-blue-500 shadow-lg flex items-center justify-center transition active:scale-95 floating-btn"
        style={{ boxShadow: "0 6px 24px #0002" }}
        onClick={() => navigate("/cart")}
        aria-label="Giỏ hàng"
      >
        <i className="fa fa-shopping-cart text-white text-2xl"></i>
        {cartCount > 0 && (
          <span className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full border border-white">
            {cartCount}
          </span>
        )}
      </button>
    </div>
  );
};
